import { ItemConfirm } from "../components/itemConfirm";

export default class DataOperationError {
    noT_FOUND?:string;
    erroR_SAVING?:string;
    checK_BUSINESS_ERRORS?:string;
    REQUEST_ERROR?:string;
    logginG_ERROR?:string;
    entitY_ERROR?:string;

    static getErrors = (err:DataOperationError):ItemConfirm[] => {
        let itemConfirms:ItemConfirm[] = [];
        if ( err.noT_FOUND != undefined )
            itemConfirms.push({ display: true, title: "Non trouvé", progress: true, type: "danger", body: err.noT_FOUND } as ItemConfirm );
        if ( err.erroR_SAVING != undefined )
            itemConfirms.push({ display: true, title: "Erreur de sauvegarde", progress: true, type: "danger", body: err.erroR_SAVING } as ItemConfirm);
        if ( err.checK_BUSINESS_ERRORS != undefined )
            itemConfirms.push({ display: true, title: "Erreur métier", progress: true, type: "warning", body: err.checK_BUSINESS_ERRORS } as ItemConfirm);
        if ( err.REQUEST_ERROR != undefined )
            itemConfirms.push({ display: true, title: "Erreur", progress: true, type: "danger", body: err.REQUEST_ERROR } as ItemConfirm);
        if ( err.logginG_ERROR != undefined )
            itemConfirms.push({ display: true, title: "Erreur", progress: true, type: "danger", body: err.logginG_ERROR } as ItemConfirm);
        if ( err.entitY_ERROR != undefined )
            itemConfirms.push({ display: true, title: "Erreur", progress: true, type: "danger", body: err.entitY_ERROR } as ItemConfirm);
        return itemConfirms;
    }
}